<div class="layout-app">
  <app-header-unauth></app-header-unauth>
  <div class="layout-main">
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
